const Toptext = ({first, second}) => {
    return(
        <>
            <h1 className='intro-title publicity-title'>{first}<strong>{second}</strong></h1>
        </>
    )
}

export default Toptext